import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { shiftPhysiotherapyRequest } from '../../../services/api/cashless-physiotherapy-v2';

const PhysiotherapyShiftRequestModal = ({
    isOpen,
    onClose,
    requestId,
    onComplete,
    className = 'bg-info',
}) => {

    const [loading, setLoading] = useState(false)

    const onSubmit = () => {
        setLoading(true)
        shiftPhysiotherapyRequest(requestId)
        .then((response) => {
            if (response.message === 'success') {
                toast.success('Successfully shifted request')
                return
            }
            throw new Error('Error while shifting request')
        })
        .catch((err) => {
            toast.error('Error while shifting request')
        })
        .finally(() => {
            setLoading(false)
            onClose()
            onComplete()
        })
    }

    return <Modal isOpen={isOpen} toggle={onClose}>
        <ModalHeader className={className} toggle={onClose}>
            Shift Request ({requestId})
        </ModalHeader>
        <ModalBody>Are you sure want to shift the request to pending?</ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={onSubmit} disabled={loading}>
                {loading ? 'Loading...' : 'Shift'}
            </Button>
            {!loading && (
                <Button color="secondary" onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
            )}
        </ModalFooter>
    </Modal>
}

export default PhysiotherapyShiftRequestModal